module.exports = __webpack_public_path__ + "img/interior-gallery-5.59f42f2f.jpg";